'use client'

import React, { ErrorInfo } from 'react'

type State = {
  hasError: boolean
  error: Error | null
}

type Props = {
  fallback?: React.ReactNode
  children: React.ReactNode
}

class ErrorBoundary extends React.Component<Props, State> {
  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }

  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // TODO: Report error to new relic?
    // eslint-disable-next-line no-console
    console.error('Client side error caught by ErrorBoundary', { error, info })
  }

  resetBoundary() {
    this.setState({ hasError: false, error: null })
  }

  handleErrorFallback() {
    return (
      <div role="alert">
        <p>Something went wrong:</p>
        <pre style={{ color: 'red' }}>{this.state.error?.message}</pre>
        <button onClick={this.resetBoundary}>Try again</button>
      </div>
    )
  }

  render() {
    if (this.state.hasError && process.env.NODE_ENV === 'development') {
      return <h4>ERROR (dev mode)</h4>
    }

    if (this.state.hasError) {
      return this.props.fallback || this.handleErrorFallback()
    }

    return this.props.children
  }
}

export default ErrorBoundary
